import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';

export const sdkRoutes: Routes = [
  {
    path: 'desbloqueio-usuario',
    loadChildren: () =>
      import('../pages/sdk/desbloqueio-usuario/desbloqueio-usuario.module').then(
        (module) => module.DesbloqueioUsuarioModule
      ),
    canActivate: [AuthGuard],
  },
];

